var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEveryDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-20 -20 140 140",
    xmlSpace: "preserve",
    "data-icon": "true",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.107,72.352H15.893L0,89.85h100L84.107,72.352z M33.171,82.354H12.717l2.18-2.513h18.999L33.171,82.354z     M39.353,82.354l0.728-2.513h19.838l0.728,2.513H39.353z M66.104,79.842h19.002l2.177,2.514H66.827L66.104,79.842z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.166,18.255c-0.031,0-0.063,0.001-0.094,0.001c-0.028,0-0.061-0.001-0.092-0.001H51.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.447,10.152c-11.112,0-20.121,9.009-20.121,20.122c0,8.734,5.573,16.146,13.349,18.93l6.771,18.431l6.777-18.431     c7.771-2.785,13.346-10.196,13.346-18.93C70.568,19.161,61.559,10.152,50.447,10.152z M58.036,29.938v9.056h-6.451v-5.413h-2.913     v5.413h-6.456v-9.056h-2.499l10.411-10.613l3.744,3.818v-1.947h2.915v4.92l3.749,3.822H58.036z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryDay);
export default __webpack_public_path__ + "static/media/everyDay.6c305397b541fbcaa88b1c0182b8bf65.svg";
export { ForwardRef as ReactComponent };